export default "__VITE_ASSET__c3rsHK9L__"